import { filter } from 'lodash'

const states = [
    {
        id: 'new',
        label: 'Nový',
        icon: 'fa-gift',
        color: 'Turquoise',
    },
    {
        id: 'active',
        label: 'V řešení',
        icon: 'fa-play-circle',
        color: 'GreenYellow',
    },
    {
        id: 'done',
        label: 'Hotovo',
        icon: 'fa-check-circle',
        color: 'ForestGreen',
    },
    {
        id: 'archive',
        label: 'Archiv',
        icon: 'fa-archive',
        color: 'RoyalBlue',
    },
]

export default states

export const active = filter(states, s => s.id !== 'archive')
export const inactive = filter(states, s => s.id === 'archive')
